import React, {useEffect, useState} from 'react'
import { Parallax } from 'react-parallax';


export default function HeroParallax({ bgImg, text, extraStyling, extraComponent, short }) {
  const [screenSize, setScreenSize] = useState('mobile')

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth > 639 && window.innerWidth <= 1024) {
                setScreenSize('tablet')
            }
            if(window.onresize) {
                if (window.innerWidth > 639 && window.innerWidth <= 1024) {
                    setScreenSize('tablet')
                } else {
                    setScreenSize('mobile')
                }
            }
        }
    }, [])
    
    return (
        <div className="mb-5">
            <Parallax
                bgImage={bgImg}
                strength={700}
                bgImageStyle={{
                    width: '100%',
                    height: screenSize === 'tablet' || short ? '50vh' : '80vh',
                    objectFit: 'cover',
                    opacity: '0.6',
                }}>
            <div style={{height: screenSize === 'tablet' || short? '50vh':'80vh'}}>
                <h1 className={"heroH1 " + extraStyling}>{text}</h1>
                {extraComponent? extraComponent:null}
            </div>
            </Parallax>
        </div>
    )
}
